export const userIsSubscriber = (user) => {
  if (!user) return false;

  let usuarioAssinante = (!!user.id_contrato && !!user.descricao_plano) || user.titular === false;

  if (usuarioAssinante && user.qntdeParcelas?.countParcelas && user.qntdeParcelas?.countParcelas > 0) {
    let data_parcela = user?.qntdeParcelas?.datasParcelas !== null ? new Date(user?.qntdeParcelas?.datasParcelas[0]) : null;
    if (data_parcela !== null) {
      const dia = user?.qntdeParcelas?.forma_pagamento === 13 ? 60 : 0;
      data_parcela.setDate(data_parcela?.getDate() + dia);
      const dataAtual = new Date();
      if (dataAtual >= data_parcela) {
        usuarioAssinante = false;
      }
    }
  }

  return usuarioAssinante ? true : false;
};

export const getAppTheme = (subscriber) => {

  return subscriber ? subscriberTheme : defaultTheme;
};

export const subscriberTheme = {
  fontcolor: 'white',
  background: '#5AB2AE',
  color: '#5AB2AE',
};

export const defaultTheme = {
  fontcolor: 'white',
  background: '#5AB2AE',
  color: '#5AB2AE',
};

